// ============================================================
// RevisionGamme — CORRIGER LA GAMME EN LA REGARDANT
// ------------------------------------------------------------
// Un seul champ portait deux gestes de nature opposée :
//
//   AVANT  « comment usineriez-vous cette pièce ? »  → ça ORIENTE
//   APRÈS  « non, prends le NLX sur l'OP 20 »        → ça CORRIGE
//
// Les deux s'empilaient dans `consigne_gamme`, et la phrase de départ
// repartait au modèle à chaque estimation, mêlée aux corrections. Le
// premier vit désormais en tête, contre le dessin ; celui-ci vit ICI,
// sous la gamme, parce qu'on ne corrige pas ce qu'on ne voit pas.
//
// ── PAS D'HISTORIQUE AFFICHÉ — décision de Charles, 27 août 2026 ──
//
// « Je ne pense pas qu'il faille afficher l'historique, par contre il
// faut le garder en mémoire de corrections. » Il a raison : ce qui
// compte n'est pas de relire ce qu'on a tapé — le DIFF juste au-dessus
// montre déjà ce que la phrase a changé — c'est que le programme s'en
// souvienne pour les pièces comparables.
//
// La phrase part donc dans `correction_justification`, qui est la
// colonne de « pourquoi avez-vous corrigé ? », et de là dans
// `ai_corrections.justification` à l'enregistrement. C'est elle que
// l'agent relira dans six mois, pas le chiffre.

import { useState } from 'react';
import { Textarea } from '../../ui/TextField.jsx';
import Button from '../../ui/Button.jsx';

export function RevisionGamme({ onReviser, revising = false, disabled = false }) {
  const [message, setMessage] = useState('');

  function envoyer() {
    const texte = message.trim();
    if (!texte) return;
    onReviser(texte);
    // Le champ se vide : ce qui a été demandé se lit dans le DIFF
    // au-dessus, pas dans la case. Une case qui garde la phrase
    // précédente invite à la renvoyer telle quelle.
    setMessage('');
  }

  return (
    <div className="revision-gamme">
      <Textarea
        label="Corriger cette gamme"
        rows={Math.max(4, message.split('\n').length + 1)}
        value={message}
        disabled={disabled || revising}
        placeholder="« l’OP 20 se fait sur le NLX, pas sur le CTX » · « ajoute un ébavurage »"
        hint="Une phrase, une révision. L’agent RÉVISE la gamme ci-dessus — il n’en refait pas une neuve — et vous verrez ce qui change. Votre phrase est retenue pour les pièces comparables."
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => {
          // Entrée envoie, Maj+Entrée passe à la ligne. C'est la
          // convention d'un champ de message, et elle évite le
          // aller-retour à la souris pour une phrase de six mots.
          if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); envoyer(); }
        }}
      />
      <div className="row row--between">
        <Button
          size="sm"
          variant="primary"
          disabled={disabled || revising || !message.trim()}
          onClick={envoyer}
        >
          {revising ? 'Révision en cours…' : 'Réviser la gamme'}
        </Button>
        <span className="field__hint">
          Entrée pour envoyer, Maj+Entrée pour aller à la ligne.
        </span>
      </div>
    </div>
  );
}

export default RevisionGamme;
